/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { HolidayCalendarModelDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class HolidaysClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags Holidays
   * @name HolidaysGet
   * @summary Returns the Holidays.
   * @request GET:/holidays
   */
  holidaysGet = (params: RequestParams = {}) =>
    this.http.request<HolidayCalendarModelDto[], any>({
      path: `/holidays`,
      method: "GET",
      format: "json",
      ...params,
    });
}
